export class FieldAutofillOption {
	displayString: string;
	applyString: string;
}